import { render, staticRenderFns } from "./page-team-dashboard.vue?vue&type=template&id=3944fdc1&scoped=true"
import script from "./page-team-dashboard.vue?vue&type=script&lang=js"
export * from "./page-team-dashboard.vue?vue&type=script&lang=js"
import style0 from "./page-team-dashboard.vue?vue&type=style&index=0&id=3944fdc1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3944fdc1",
  null
  
)

export default component.exports